export default "__VITE_ASSET__DjeUGQKd__"